import * as React from 'react';

function SvgStateWarning(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" ref={svgRef} {...props}>
      <path
        d="M8 10.771a1.03 1.03 0 100 2.059 1.03 1.03 0 100-2.059zM8 3.89a1.031 1.031 0 00-1.031 1.031v4.123a1.031 1.031 0 102.062 0V4.921A1.031 1.031 0 008 3.89zm1.4-2.059L15.768 12.5a1.629 1.629 0 01-1.4 2.464H1.631A1.629 1.629 0 01.232 12.5L6.6 1.831a1.629 1.629 0 012.8 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgStateWarning);
export default ForwardRef;
